const clients = $('.our-clients-item').get();

/* Filters */ 

const industryButton = $('#industry').get()[0];
const countryButton = $('#country').get()[0];
const clearFiltersButton = $('.our-clients-filter-clear-button').get()[0];
const clearFiltersButtonMobile = $('.our-clients-filter-clear-button-mobile').get()[0];
const industryArrow = $('#industry-arrow').get()[0];
const countryArrow = $('#country-arrow').get()[0];
const industryDropdown = $('#industry-list').get()[0];
const countryDropdown = $('#country-list').get()[0];
const industryFilters = $('.our-clients-industry-filter-list-item-checkbox').get();
const countryFilters = $('.our-clients-country-filter-list-item-checkbox').get();
const industryFilterChips = $('.our-clients-industry-filter-chips-item').get();
const countryFilterChips = $('.our-clients-country-filter-chips-item').get();
const filterChipsContainer = $('.our-clients-filters-chips').get()[0];
const filterChipsPrev = $('.our-clients-filters-chips-prev').get()[0];
const filterChipsNext = $('.our-clients-filters-chips-next').get()[0];
const filterRadio = $('.our-clients-filters__item label');
const filterList = $('.our-clients-filter__list');
const industryFiltersNew = $('[data-filter="category"] button:not(.our-clients-filter__clear)').get();
const countryFiltersNew = $('[data-filter="country"] button:not(.our-clients-filter__clear)').get();
const clearAllButton = $('.our-clients-filter__clear');
const arrowClose = $('.our-clients-filter__close');

industryButton.onclick = () => {
    if (industryDropdown.classList.contains("show")) {
        industryDropdown.classList.remove("show");
        industryArrow.style.transform = "rotate(180deg)";
    } else {
        industryDropdown.classList.add("show");
        industryArrow.style.transform = "rotate(0deg)";
        $('html, body').animate({
            scrollTop: window.scrollY + industryButton.getBoundingClientRect().top - 80
        }, 500);
    }
    if (countryDropdown.classList.contains("show")) {
        countryDropdown.classList.remove("show");
        countryArrow.style.transform = "rotate(180deg)";
    }
};

industryDropdown.onclick = (event) => {
    event.stopPropagation();
};

countryButton.onclick = () => {
    if (countryDropdown.classList.contains("show")) {
        countryDropdown.classList.remove("show");
        countryArrow.style.transform = "rotate(180deg)";
    } else {
        countryDropdown.classList.add("show");
        countryArrow.style.transform = "rotate(0deg)";
        $('html, body').animate({
            scrollTop: window.scrollY + countryButton.getBoundingClientRect().top - 80
        }, 500);
    }
    if (industryDropdown.classList.contains("show")) {
        industryDropdown.classList.remove("show");
        industryArrow.style.transform = "rotate(180deg)";
    }
};

countryDropdown.onclick = (event) => {
    event.stopPropagation();
};

window.onclick = function(event) {
    if (!event.target.matches('#industry-button') &&
        !event.target.matches('.our-clients-industry-filter-list-item-checkbox')) {
        if (industryDropdown.classList.contains("show")) {
            industryDropdown.classList.remove("show");
            industryArrow.style.transform = "rotate(180deg)";
        }
    }
    if (!event.target.matches('#country-button') &&
        !event.target.matches('.our-clients-country-filter-list-item-checkbox')) {
        if (countryDropdown.classList.contains("show")) {
            countryDropdown.classList.remove("show");
            countryArrow.style.transform = "rotate(180deg)";
        }
    }
};

clearFiltersButton.onclick = () => {
    industryFilters.forEach(filter => {
        filter.checked = false;
    });
    industryFilterChips.forEach(chips => {
        chips.style.display = "none";
    });
    countryFilters.forEach(filter => {
        filter.checked = false;
    });
    countryFilterChips.forEach(chips => {
        chips.style.display = "none";
    });
    clearFiltersButton.style.display = "none";
    clearFiltersButtonMobile.style.display = "none";
    clients.forEach(client => {
        client.style.display = "flex";
    });
    filterChipsPrev.style.display = "none";
    filterChipsNext.style.display = "none";
};

clearFiltersButtonMobile.onclick = () => {
    industryFilters.forEach(filter => {
        filter.checked = false;
    });
    industryFilterChips.forEach(chips => {
        chips.style.display = "none";
    });
    countryFilters.forEach(filter => {
        filter.checked = false;
    });
    countryFilterChips.forEach(chips => {
        chips.style.display = "none";
    });
    clearFiltersButton.style.display = "none";
    clearFiltersButtonMobile.style.display = "none";
    clients.forEach(client => {
        client.style.display = "flex";
    });
    filterChipsPrev.style.display = "none";
    filterChipsNext.style.display = "none";
};


const checkActiveFilters = () => {
    const isActiveIndustryFilters = industryFilters.find(filter => filter.checked);
    const isActiveCountryFilters = countryFilters.find(filter => filter.checked);
    const isActiveIndustryFiltersNew = industryFiltersNew.find(filter => $(filter).hasClass('active'));
    const isActiveCountryFiltersNew = countryFiltersNew.find(filter => $(filter).hasClass('active'));
    if (isActiveIndustryFilters || isActiveCountryFilters || isActiveIndustryFiltersNew || isActiveCountryFiltersNew) {
        return true;
    }
    return false;
};

const clientsFilter = () => {
    const clientsFilterParams = [];
    const clientsResult = [];
    industryFilters.forEach(filter => {
        if(filter.checked) {
            clientsFilterParams.push(filter.name);
        }
    });
    countryFilters.forEach(filter => {
        if(filter.checked) {
            clientsFilterParams.push(filter.name);
        }
    });

    industryFiltersNew.forEach(filter => {
        if ($(filter).hasClass('active')) {
            clientsFilterParams.push($(filter).data('name'));
        }

    });
    countryFiltersNew.forEach(filter => {
        if ($(filter).hasClass('active')) {
            clientsFilterParams.push($(filter).data('name'));
        }

    });
    clientsFilterParams.forEach(filter => {

        clients.forEach(client => {
            if (client.getAttribute('data-client-category').replace(/\s/g, '') === filter.replace(/\s/g, '')) {
                clientsResult.push(client);
            }
            if (client.getAttribute('data-client-country').replace(/\s/g, '') === filter.replace(/\s/g, '')) {
                clientsResult.push(client);
            }
        });
    });
    clients.forEach(client => {
        client.style.display = "none";
    });
    clientsResult.forEach(client => {
        client.style.display = "flex";
    });
};
 
industryFilters.forEach(filter => {
    filter.onchange = () => {
        let filterChips = $(`#industry-chips-${filter.id}`).get()[0];

        if (filter.checked) {
            filterChips.style.display = "block";
            if ($(window).width() > 640) {
                if (clearFiltersButton.style.display !== "flex") {
                    clearFiltersButton.style.display = "flex";
                }
            } else {
                if (clearFiltersButtonMobile.style.display !== "flex") {
                    clearFiltersButtonMobile.style.display = "flex";
                }
            }
            clientsFilter();
        } else {
            filterChips.style.display = "none";
            if (!checkActiveFilters()) {
                clearFiltersButton.style.display = "none";
                clearFiltersButtonMobile.style.display = "none";
                clients.forEach(client => {
                    client.style.display = "flex";
                });
            } else {
                clientsFilter();
            }
        }

        if (filterChipsContainer.scrollWidth > filterChipsContainer.clientWidth && filterChipsContainer.scrollWidth > 1) {
            if (filterChipsContainer.scrollLeft === 0) {
                filterChipsPrev.style.display = "none";
            } else {
                if ($(window).width() > 640) {
                    filterChipsPrev.style.display = "block";
                }
            }

            if (filterChipsContainer.scrollWidth === filterChipsContainer.scrollLeft + filterChipsContainer.clientWidth) {
                filterChipsNext.style.display = "none";
            } else {
                if ($(window).width() > 640) {
                    filterChipsNext.style.display = "block";
                }
            }
        } else {
            filterChipsPrev.style.display = "none";
            filterChipsNext.style.display = "none";
        }
    }
});

countryFilters.forEach(filter => {
    filter.onchange = () => {
        let filterChips = $(`#country-chips-${filter.id}`).get()[0];

        if (filter.checked) {
            filterChips.style.display = "block";
            if ($(window).width() > 640) {
                if (clearFiltersButton.style.display !== "flex") {
                    clearFiltersButton.style.display = "flex";
                }
            } else {
                if (clearFiltersButtonMobile.style.display !== "flex") {
                    clearFiltersButtonMobile.style.display = "flex";
                }
            }
            clientsFilter();
        } else {
            filterChips.style.display = "none";
            if (!checkActiveFilters()) {
                clearFiltersButton.style.display = "none";
                clearFiltersButtonMobile.style.display = "none";
                clients.forEach(client => {
                    client.style.display = "flex";
                });
            } else {
                clientsFilter();
            }
        }

        if (filterChipsContainer.scrollWidth > filterChipsContainer.clientWidth && filterChipsContainer.scrollWidth > 1) {
            if (filterChipsContainer.scrollLeft === 0) {
                filterChipsPrev.style.display = "none";
            } else {
                if ($(window).width() > 640) {
                    filterChipsPrev.style.display = "block";
                }
            }

            if (filterChipsContainer.scrollWidth === filterChipsContainer.scrollLeft + filterChipsContainer.clientWidth) {
                filterChipsNext.style.display = "none";
            } else {
                if ($(window).width() > 640) {
                    filterChipsNext.style.display = "block";
                }
            }
        } else {
            filterChipsPrev.style.display = "none";
            filterChipsNext.style.display = "none";
        }
    }
});

filterChipsPrev.onclick = () => {
    filterChipsContainer.scrollLeft -= 200;
};

filterChipsNext.onclick = () => {
    filterChipsContainer.scrollLeft += 200;
};

filterChipsContainer.addEventListener('scroll', () => {
    if (!filterChipsContainer.scrollLeft) {
        filterChipsPrev.style.display = "none";
    } else {
        if ($(window).width() > 640) {
            filterChipsPrev.style.display = "block";
        }
    }

    if (filterChipsContainer.scrollWidth <= filterChipsContainer.scrollLeft + filterChipsContainer.clientWidth + 1) {
        filterChipsNext.style.display = "none";
    } else {
        if ($(window).width() > 640) {
            filterChipsNext.style.display = "block";
        }
    }
});

/* Modal-Slider */

const modalSliderWrapper = $('.modal-clients-slider')[0];
let modalSlider;
const sliderNode = document.getElementById("modal-slider");
const serializer = new XMLSerializer();
const sliderNodeStr = serializer.serializeToString(sliderNode);
localStorage.setItem("sliderNode", sliderNodeStr);

function onSlickReady(callback) {
    if (typeof window.mobidevOnSlickReady === 'function') {
        window.mobidevOnSlickReady(callback);
        return;
    }
    if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) {
        callback();
    }
}

function removeHash () {
    history.replaceState(null, document.title, window.location.pathname + window.location.search);
};

function changeHash (slideID) {
    history.replaceState(null, document.title, window.location.pathname + window.location.search + `#tab-${slideID}`);
};

function removeInactiveClientsSlides () { 
    const inactiveClients = clients.filter(client => client.style.display === "none");
    inactiveClients.forEach((client, index) => {
        modalSlider.slick('slickRemove', client.getAttribute("data-client-index") - index);
    });
};

function initModalSlider () {
    if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) {
        onSlickReady(initModalSlider);
        return;
    }

    modalSlider = $('#modal-slider');

    modalSlider.slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
		arrows: true,
        speed: 1
    });

    modalSlider.on('afterChange', () => {
        const activeClientSlide = $('.modal-clients-slider .slick-current').get()[0];
        const activeClientSlideID = activeClientSlide.getAttribute("data-client-id");
        changeHash(activeClientSlideID);
    });

    const modalSliderContainer = $('.modal-clients-slider').get()[0];
    const modalSliderCloseButtons = $(".modal-clients-slider-close-button").get();
    const whatsappButton = $('#whatsapp-button').get()[0];

    clients.forEach(client => {
        client.onclick = (e) => {
            localStorage.setItem("modalSliderStartPosition", e.pageY - 200);

            client.style.cursor='default';

            setTimeout(() => {
                const currentClientIndex = () => {
                    const activeClients = clients.filter(activeClient => activeClient.style.display !== "none")
                        .findIndex(activeClient => activeClient.getAttribute('id') === client.getAttribute('id'));
                    return activeClients;
                }
                
                $('body').get()[0].style.overflow = "hidden";
    
                if (whatsappButton) {
                    whatsappButton.style.display = 'none';
                }
    
                modalSlider.slick('slickGoTo', currentClientIndex());
                modalSliderContainer.style.display = 'block';
                modalSlider.slick('slickSetOption', 'speed', 500, true);
    
                if (checkActiveFilters()) {
                    removeInactiveClientsSlides();
                }
            }, 30);
        }
    });

    modalSliderCloseButtons.forEach(button => {
        button.onclick = () => {
            modalSliderContainer.style.display = 'none';
            removeHash();
            $('body').get()[0].style.overflow = "auto";
            if (whatsappButton && whatsappButton.style.display === 'none') {
                whatsappButton.style.display = 'block';
            }

            setTimeout(() => {
                modalSlider.slick('slickSetOption', 'speed', 1, true);
                modalSlider.slick('unslick');
                modalSliderWrapper.innerHTML = localStorage.getItem("sliderNode");
                initModalSlider();
                clients.forEach(client => {
                    client.style.cursor='pointer';
                });
            }, 250);
        };
    });
};

$(window).on('stopResize orientationchange', function (event) {
    if ($(window).width() < 641) {
        if (clearFiltersButton.style.display === "flex") {
            clearFiltersButton.style.display = "none";
            clearFiltersButtonMobile.style.display = "flex";
            filterChipsPrev.style.display = "none";
            filterChipsNext.style.display = "none";
        }
    }
    if ($(window).width() > 640) {
        if (clearFiltersButtonMobile.style.display === "flex") {
            clearFiltersButtonMobile.style.display = "none";
            clearFiltersButton.style.display = "flex";
        }
    }
});

function setBottomLineToArticleItems () {
    let article_items = $('.mobi-article__item');

    for (let i = 0; i < article_items.length - 1; i++) {
        $('.mobi-article__item-' + i).each(function(index, elem) {
            let additional_width = 60;
            if (window.innerWidth < 1500) {
                additional_width = 50;
            } else if (window.innerWidth < 1200) {
                additional_width = 0;
            }

            if (window.innerWidth < 992) {
                $('.mobi-article__line').css('width', '100%');
            } else {
                var children = [...elem.children];
                let total_width = 0;
                children.forEach(function (child) {
                    total_width += $(child).innerWidth();
                });

                $('.mobi-article__line-' + i).css('width', (total_width + additional_width) + 'px');
                total_width = 0;
            }
            $('.mobi-article__line').css('display', 'block');
        });
    }
}

$(window).on('resize', function () {
    setBottomLineToArticleItems();
    // checkHeightFilterList()
    // arrowClose.removeClass('active');
});
checkHeightFilterList()

function checkHeightFilterList(value = null) {
    if (window.innerWidth < 640) {
        let list = '';
        if (value == null) {
            list = $('.our-clients-filter__list');
        } else {
            list = $('[data-filter="' + value + '"]');
        }
        list.height('auto');
        if (list.outerHeight() <= 185) {
            arrowClose.css('display', 'none')
        } else {
            arrowClose.css('display', 'block')
            list.height(185);
        }
    }
}

clearAllButton.on('click', function (e) {
    industryFiltersNew.forEach(filter => {
        $(filter).removeClass('active')
    });
    countryFiltersNew.forEach(filter => {
        $(filter).removeClass('active')
    });

    clearAllButton.removeClass('active');
    clients.forEach(client => {
        client.style.display = "flex";
    });
});
arrowClose.on('click', function (e) {
    arrowClose.toggleClass('active');
    if (arrowClose.hasClass('active')) {
        $('.our-clients-filter__list').height('auto');
    } else {
        $('.our-clients-filter__list').height(185);
    }
})
filterRadio.on('click', function (e) {
    const parentDiv = $(this).closest('.our-clients-filters__item');
    const value = parentDiv.find('input').val();

    filterList.css('display', 'none');
    $('[data-filter="'+value+'"]').css('display', 'flex');

    $('.our-clients-filter__list').not('[data-filter="'+value+'"]').children('button:not(.our-clients-filter__clear)').removeClass('active');
    clientsFilter();
    if (!$('.our-clients-filter__list button:not(.our-clients-filter__clear)').hasClass('active')) {
        clients.forEach(client => {
            client.style.display = "flex";
        });
    }
    arrowClose.removeClass('active');
    clearAllButton.removeClass('active')
    checkHeightFilterList(value);
})
$('.our-clients-filter__list button:not(.our-clients-filter__clear)').on('click', function (e) {
    $(this).toggleClass('active');
    clientsFilter();
    if (!$('.our-clients-filter__list button:not(.our-clients-filter__clear)').hasClass('active')) {
        clients.forEach(client => {
            client.style.display = "flex";
        });
        clearAllButton.removeClass('active');
    } else  {
        clearAllButton.addClass('active');
    }
});

sliderCaseStudy();
function sliderCaseStudy() {
    var onSwiperReady = window.mobidevOnSwiperReady || function (cb) {
        if (typeof Swiper !== 'undefined') {
            cb();
        }
    };
    onSwiperReady(function () {
        document.querySelectorAll('.case-studies__slider-js').forEach((sliderEl, index) => {
            const paginationEl = sliderEl.querySelector('.case-studies__slider-pagination');
            const nextBtn = sliderEl.querySelector('.case-studies__slider-next');
            const prevBtn = sliderEl.querySelector('.case-studies__slider-prev');

            new Swiper(sliderEl, {
                slidesPerView: 1,
                speed: 1000,
                spaceBetween: 24,
                loop: true,

                pagination: paginationEl ?
                    {
                        el: paginationEl,
                        clickable: true,
                    } :
                    false,

                navigation: nextBtn && prevBtn ?
                    {
                        nextEl: nextBtn,
                        prevEl: prevBtn,
                    } :
                    false,

                breakpoints: {
                    640: {
                        spaceBetween: 50,
                    },
                    1200: {
                        spaceBetween: 34,
                    },
                },
            });
        });
    });
    // $slider.on('afterChange', function(event, slick) {
    //     changeHeightCaseStudy();
    // });
}

// changeHeightCaseStudy()
// function changeHeightCaseStudy() {
//     if (window.innerWidth > 991) {
//         var slickTrack = $('.case-studies .slick-track');
//         var currentSlideHeight = $('.slick-active .case-study__container').height() + 120;
//
//         slickTrack.animate(
//             { height: currentSlideHeight },
//             {
//                 duration: 200,
//                 easing: 'swing',
//             }
//         );
//     }
//
// }

clickTestimonials();
function clickTestimonials() {
    if (!$('.testimonial_item').hasClass('active')) {
        $('.testimonial_item').first().addClass('active');
    }
    $('.testimonial_item a').on('click', function (e) {
        $('.testimonial_item').removeClass('active');
        $(this).closest('.testimonial_item').addClass('active');
    });
}


$(function() {
    setBottomLineToArticleItems();
    const initialHash = window.location.hash;

    // Disabled: extra history entry broke normal Back navigation (required several Back presses to get to prevous page). 
    // https://jira.mobidev.biz/browse/MDR-2896
    // https://jira.mobidev.biz/browse/MDR-4819
    // history.pushState(null, null, './clients-and-testimonials');

    window.addEventListener("hashchange", () => {
        if (window.location.hash) {
            const modalSliderContainer = $('.modal-clients-slider').get()[0];
            modalSliderContainer.style.display = 'none';
            removeHash();
            window.location.reload();
        }
    });

    window.addEventListener("popstate", () => {
        if (window.location.hash) {
            if (!modalSlider || !window.jQuery.fn.slick) {
                return;
            }
            const activeClientID = location.hash.slice(5);
            const modalSliderContainer = $('.modal-clients-slider').get()[0];
            const whatsappButton = $('#whatsapp-button').get()[0];

            const currentClientIndex = () => {
                const activeClients = clients.filter(activeClient => activeClient.style.display !== "none")
                    .findIndex(activeClient => activeClient.getAttribute('id') === activeClientID);
                return activeClients;
            }
            
            $('body').get()[0].style.overflow = "hidden";

            if (whatsappButton) {
                whatsappButton.style.display = 'none';
            }

            modalSlider.slick('slickGoTo', currentClientIndex());
            modalSliderContainer.style.display = 'block';
            modalSlider.slick('slickSetOption', 'speed', 500, true);
        } else {
            window.location.reload();
        }
    });

    document.addEventListener("fullscreenchange", (event) => {
        if (window.location.hash.length) {
            $('body').get()[0].style.overflow = "scroll";
            let modalSliderStartPosition = Number(localStorage.getItem("modalSliderStartPosition"));
            event.target.parentElement.parentElement.scrollTo(0, event.target.parentElement.parentElement.scrollHeight);
            window.scrollTo({
                top: modalSliderStartPosition,
                left: 0,
                behavior: "instant",
            });
            $('body').get()[0].style.overflow = "hidden";
        }
    });

    onSlickReady(initModalSlider);

    if (initialHash.length) {
        const activeClientID = initialHash.slice(5);
        const activeClient = clients.find(client => client.id == activeClientID);
        activeClient.click();
    }

    /* Testimonials-Slider */

    const testimonialsSlider = $('#testimonials-slider');

    onSlickReady(function () {
        if (!window.jQuery.fn.slick) {
            return;
        }
        testimonialsSlider.slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            arrows: true,
            dots: true,
        });
    });


    /* Testimonials-Slider-Mobile */

    const testimonialsSliderMobile = $('#testimonials-slider-mobile');

    onSlickReady(function () {
        if (!window.jQuery.fn.slick) {
            return;
        }
        testimonialsSliderMobile.slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            arrows: true,
            variableWidth: true,
            dots: true,
        });
    });
});
